import React from 'react';
import TopTitleBlock from '../../../Components/TopTitleBlock/TopTitleBlock';
import {useTranslation} from 'react-i18next';
import {useLocation} from 'react-router-dom';
import {
	RequestCreateCashierOrderType,
	RequestEditCashierOrderType,
} from '../../../types/CashierSliceStateType';

import CreateEditCashForm from '../components/CreateEditCashForm';
import {useStatusRestriction} from '../../../hooks/useStatusRestriction';
import StatusRestrictionMessage from '../../../Components/StatusRestrictionMessage/StatusRestrictionMessage';

const CreateCashOrder = () => {
	const {t} = useTranslation();
	const location = useLocation();
	const restrictions = useStatusRestriction();

	if (!restrictions.canAccessCashOrders) {
		return (
			<div className="page__content">
				<StatusRestrictionMessage message={t('Сторінка недоступна')} />
			</div>
		);
	}

	// Перевіряємо, чи є дані для редагування
	const editData = location.state?.editData;
	const isEdit = !!editData;

	const initialValues: RequestCreateCashierOrderType | RequestEditCashierOrderType = isEdit
		? {
			amount: editData.amount,
			account_id: editData.account_id,
			comment: editData.comment,
			order_id: editData.order_id,
		}
		: {
			amount: '',
			account_id: '',
			comment: '',
		};
	return (
		<div className="page__content">
			<TopTitleBlock
				title={t('СПИСОК КАСОВИХ ОРДЕРІВ')}
				link={'/cash_order_list'}
			/>
			<CreateEditCashForm
				initialValues={initialValues}
				title={isEdit ? t('Редагувати касовий ордер') : t('Створити касовий ордер')}
				type={isEdit ? 'edit' : 'create'}
			/>
		</div>
	);
};

export default CreateCashOrder;
